<ng-container *ngIf="HasRequiredPermissions">
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">

    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ `entities.truckerActivity.pluralName` | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
                   [contextMenuItems]="contextMenuItems"
                   [showActions]="true"
                   [canEdit]="canEdit.bind(this)"
                   (entitySelected)="selectSingleItem($event)"
                   (editAction)="editSelectedItem($event)"
                   (deleteAction)="deleteSelectedItem($event)"
                   [ShowRangeDateFilter]="true"
                   [fuseauxParSite]="fuseauxParSite"
                   [dismissEntity]="dismissEntityState.bind(this)"
                   [onDismissAdded]="dismissEntityState.bind(this)"
                   [onRowDismiss]="handleRowDismiss.bind(this)"
                   [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: ['truckerActivityID', 'trucker.fullName', 'trucker.companyName', 'trailerNumber', 'dock.iD_SP'],
                          sortableColumns: ['truckerActivityID', 'startDate', 'endDate', 'trailerNumber']
                        }"
                   [paginatorType]="'button'"
                   [showHeader]="false"
                   (createButtonClick)="openCreateModal()"
                   [listType]="ListType.Table">

  <!-- Utilisation du nouveau filtre multicritères -->
      <div slot="custom-filters" class="px-6 py-2">
        <app-multi-criteria-filter [options]="filterOptions()"
                                   [multiSelect]="true"
                                   (selectionChange)="onFilterSelectionChange($event)"
                                   clearButtonLabel="clearFilters">
        </app-multi-criteria-filter>
      </div>

      <!-- Photo Column -->
      <app-list-table-column key="imagePhoto.thumbnail_Path" title="{{ 'Photo' | translate }}" type="custom" showLabel="false" visible="true">
        <ng-template #customTemplate let-entity>
          <div class="w-12 h-12 bg-gray-100 rounded flex items-center justify-center overflow-hidden">
            @if (entity.imagePhoto?.thumbnail_Path) {
            <img [src]="rootUrl+ entity.imagePhoto.thumbnail_Path" alt="Photo" class="w-full h-full object-contain">
            } @else {
            <span class="text-gray-400 italic text-xs">No Photo</span>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <!-- ID Column -->
      <app-list-table-column key="truckerActivityID" title="{{ 'entities.truckerActivity.propreties.truckerActivityID' | translate }}" type="text" [sortable]="true" visible="true"
                             align="left"></app-list-table-column>
      <!-- Trucker Column -->
      <app-list-table-column key="trucker.fullName" title="{{ 'entities.trucker.propreties.fullName' | translate }}" type="text" [sortable]="true" showLabel="true"
                             align="left"></app-list-table-column>
      <!-- Company Column -->
      <app-list-table-column key="trucker.companyName" title="{{ 'entities.trucker.propreties.companyName' | translate }}" type="text" [sortable]="true"
                             align="left"></app-list-table-column>
      <!-- Trailer Column -->
      <app-list-table-column key="trailerNumber" title="{{ 'entities.truckerActivity.propreties.trailerNumber' | translate }}" type="text" [sortable]="true"
                             align="left"></app-list-table-column>
      <!-- Check-In Column -->
      <app-list-table-column key="startDate" title="{{ 'entities.truckerActivity.propreties.startDate' | translate }}" type="datetime" [sortable]="true"
                             align="left"></app-list-table-column>
      <!-- Check-Out Column -->
      <app-list-table-column key="endDate" title="{{ 'entities.truckerActivity.propreties.endDate' | translate }}"  type="custom"  [sortable]="true" visible="true"
                             align="left">
        <ng-template #endDateTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.endDate) {
            @if (isSameDay(entity.startDate, entity.endDate )) {
            <span class="text-gray-700">{{ getFormatedTimeValue(entity.endDate) }}</span>
            }
            @else {
            <span class="text-gray-700">{{getFormatedDateValue(entity.endDate)}}</span>
            }
            @if (fuseauDeLigne(entity); as iana) {
            <app-timezone-icon [iana]="iana"></app-timezone-icon>
            }
            }
          </div>
        </ng-template>

      </app-list-table-column>
      <!-- Status Column -->
      <app-list-table-column key="status" title="{{ 'entities.truckerActivity.propreties.status' | translate }}" type="custom" visible="true">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)" [lookupData]="activityStatusLookup()" [Skin]="Skin"
                              [isEditMode]="true" (statusChange)="updateEntityProperty(entity, 'status', $event)">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>
      <!-- Dock Column -->
      <app-list-table-column key="dock.iD_SP" title="{{ 'entities.truckerActivity.propreties.dock' | translate }}" type="text" [sortable]="true"
                             align="left"></app-list-table-column>
      <!-- Attachments Column -->
      <app-list-table-column key="attachments" title="{{ 'entities.truckerActivity.propreties.attachments' | translate }}" type="custom" visible="false">
        <ng-template #customTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.imageAgreements) {
            <i class="fas fa-file-alt text-blue-500" title="Agreements"></i>
            }
            @if (entity.imageSignature) {
            <i class="fas fa-signature text-purple-500" title="Signature"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>
    </app-list-view>

    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">

      <!-- Poignee interactive (invisible avant le survol)  -->
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white rounded-lg shadow-xl p-1 h-full">
        <app-trucker-activity-detail #truckerActivityDetail
          [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="handleItemSaved($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()"
          [fkPointOfServiceId]="fkPointOfServiceId">
        </app-trucker-activity-detail>
      </div>
    </div>
  </div>


</ng-container>
